import { About } from "./components/bmt/About";
import { Approach } from "./components/bmt/Approach";
import { BrandSignature } from "./components/bmt/BrandSignature";
import { Contact } from "./components/bmt/Contact";
import { Expertise } from "./components/bmt/Expertise";
import { Footer } from "./components/bmt/Footer";
import { Header } from "./components/bmt/Header";
import { Hero } from "./components/bmt/Hero";
import { ScrollProgressTop } from "./components/bmt/ScrollProgressTop";

export function App() {
  return (
    <>
      <a
        href="#expertise"
        className="sr-only focus:not-sr-only focus:fixed focus:left-6 focus:top-6 focus:z-[60] focus:bg-primary focus:px-4 focus:py-2 focus:text-sm focus:text-primary-foreground"
      >
        Skip to content
      </a>
      <Header />
      <main>
        <Hero />
        <Expertise />
        <Approach />
        <About />
        <Contact />
      </main>
      <Footer />
      <BrandSignature />
      <ScrollProgressTop />
    </>
  );
}
